import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IOcMeasureBounds, newEmptyBounds, OcMeasure } from './OcMeasure';

interface IOcIsolatorProps {
	onResize?: (bounds: IOcMeasureBounds) => void
	outerStyle?: React.CSSProperties
	outerClassName?: string
	innerStyle?: React.CSSProperties
	innerClassName?: string
	dbgName?: string
	children: React.ReactNode
}

@observer export class OcIsolator extends React.Component<IOcIsolatorProps> {
	@observable _bounds: IOcMeasureBounds = newEmptyBounds()

	@action _onResize = (bounds: IOcMeasureBounds) => {
		Object.assign(this._bounds, bounds);
		if (this.props.onResize) this.props.onResize(bounds);
	}

	@computed get _composedOuterStyle() : React.CSSProperties {
		return Object.assign({
			width: '100%',
			height: '100%',
			position: 'relative',
		}, this.props.outerStyle);
	}

	@computed get _composedInnerStyle() : React.CSSProperties {
		return Object.assign({
			position: 'absolute',
			overflowX: 'hidden',
			overflowY: 'hidden',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
		}, this.props.innerStyle);
	}

	render() {
		if (this.props.dbgName) {
			const bounds = this._bounds;
			// console.log('OcIsolator', this.props.dbgName, bounds.left, bounds.right);
		}

		return <OcMeasure onResize={this._onResize}>{
			({measureRef}) => <div ref={measureRef} style={this._composedOuterStyle} className={this.props.outerClassName}>
				<div style={this._composedInnerStyle} className={this.props.innerClassName}>
					{this.props.children}
				</div>
			</div>
		}</OcMeasure>;
	}
}
